(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["herdio-guided-home-2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('herdio-guided-home')) {
    customElements.define('herdio-guided-home', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.answers = {};
        const dataNode = this.querySelector('[data-space-data]');
        this.spaceData = dataNode ? JSON.parse(dataNode.textContent) : {};
        this.steps = Array.from(this.querySelectorAll('[data-step]'));
        this.progress = Array.from(this.querySelectorAll('[data-progress-step]'));
        this.bindChoices('[data-space]', 'space', 2);
        this.bindChoices('[data-size]', 'size', 3);
        this.bindChoices('[data-connection]', 'connection', 4);
        this.querySelectorAll('[data-back]').forEach((button) => button.addEventListener('click', () => this.showStep(Number(button.dataset.back))));
        const restart = this.querySelector('[data-restart]');
        if (restart) restart.addEventListener('click', () => this.resetPlanner());
      }
      bindChoices(selector, key, nextStep) {
        this.querySelectorAll(selector).forEach((button) => button.addEventListener('click', () => {
          this.querySelectorAll(selector).forEach((item) => item.setAttribute('aria-pressed', 'false'));
          button.setAttribute('aria-pressed', 'true');
          this.answers[key] = button.dataset[key];
          window.setTimeout(() => { if (nextStep === 4) this.renderResult(); this.showStep(nextStep); }, 160);
        }));
      }
      showStep(number) {
        this.steps.forEach((step) => { step.hidden = Number(step.dataset.step) !== number; });
        this.progress.forEach((item) => { const index = Number(item.dataset.progressStep); item.classList.toggle('is-active', index === number); item.classList.toggle('is-complete', index < number); });
        const status = this.querySelector('[data-planner-status]');
        if (status) status.textContent = `Step ${number} of 4`;
        const activeStep = this.steps.find((step) => Number(step.dataset.step) === number);
        const heading = activeStep?.querySelector('h3');
        if (heading) { heading.setAttribute('tabindex', '-1'); heading.focus({ preventScroll:true }); }
        if (!window.Shopify || !Shopify.designMode) {
          const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          this.querySelector('.herdio-guide-home__planner')?.scrollIntoView({ behavior, block:'start' });
        }
      }
      renderResult() {
        const space = this.spaceData[this.answers.space];
        if (!space) return;
        const size = this.querySelector(`[data-size="${this.answers.size}"] strong`)?.textContent || '';
        const connection = this.querySelector(`[data-connection="${this.answers.connection}"] strong`)?.textContent || '';
        this.setText('[data-answer-space]', space.title);
        this.setText('[data-answer-size]', size);
        this.setText('[data-answer-connection]', connection);
        this.setText('[data-fit-copy]', space.fit);
        this.setText('[data-system-title]', space.systemTitle);
        this.setText('[data-system-copy]', space.systemCopy);
        const link = this.querySelector('[data-solution-link]');
        if (link) link.href = space.url || '/pages/audio-solutions';
        const emptyLink = this.querySelector('[data-empty-solution-link]');
        if (emptyLink) emptyLink.href = space.url || '/pages/audio-solutions';
        this.renderRecommendation();
      }
      renderRecommendation() {
        this.querySelectorAll('[data-recommendations], [data-product-group], [data-product-size]').forEach((item) => { item.hidden = true; });
        this.querySelectorAll('[data-match-label]').forEach((item) => { item.textContent = item.dataset.defaultLabel || 'Best match'; });
        const panel = this.querySelector(`[data-recommendations="${this.answers.space}"]`);
        const empty = this.querySelector('[data-recommendation-empty]');
        if (!panel) { if (empty) empty.hidden = false; return; }
        panel.hidden = false;
        const requestedConnection = this.answers.connection === 'wired' ? 'wired' : 'bluetooth';
        const group = panel.querySelector(`[data-product-group="${requestedConnection}"]`);
        const product = group?.querySelector(`[data-product-size="${this.answers.size}"]`) || group?.querySelector('[data-product-size]');
        if (!group || !product) { if (empty) empty.hidden = false; return; }
        group.hidden = false;
        product.hidden = false;
        const label = product.querySelector('[data-match-label]');
        if (label && this.answers.connection === 'unsure') label.textContent = 'Simplest compatible match';
        const title = this.querySelector('[data-recommendation-title]');
        if (title) title.textContent = this.answers.connection === 'unsure' ? 'A simple system to start with' : 'Recommended for your setup';
        if (empty) empty.hidden = true;
      }
      setText(selector, value) { const node = this.querySelector(selector); if (node) node.textContent = value || ''; }
      resetPlanner() { this.answers = {}; this.querySelectorAll('[aria-pressed]').forEach((item) => item.setAttribute('aria-pressed', 'false')); this.showStep(1); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["herdio-home-experience"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('herdio-home-planner')) {
    customElements.define('herdio-home-planner', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.answers = {};
        const dataNode = this.querySelector('[data-space-data]');
        this.spaceData = dataNode ? JSON.parse(dataNode.textContent) : {};
        this.steps = Array.from(this.querySelectorAll('[data-step]'));
        this.progress = Array.from(this.querySelectorAll('[data-progress-step]'));
        this.bindChoices('[data-space]', 'space', 2);
        this.bindChoices('[data-size]', 'size', 3);
        this.bindChoices('[data-connection]', 'connection', 4);
        this.querySelectorAll('[data-back]').forEach((button) => button.addEventListener('click', () => this.showStep(Number(button.dataset.back))));
        const restart = this.querySelector('[data-restart]');
        if (restart) restart.addEventListener('click', () => this.resetPlanner());
      }

      bindChoices(selector, answerKey, nextStep) {
        this.querySelectorAll(selector).forEach((button) => {
          button.addEventListener('click', () => {
            this.querySelectorAll(selector).forEach((item) => item.setAttribute('aria-pressed', 'false'));
            button.setAttribute('aria-pressed', 'true');
            this.answers[answerKey] = button.dataset[answerKey];
            window.setTimeout(() => {
              if (nextStep === 4) this.renderResult();
              this.showStep(nextStep);
            }, 180);
          });
        });
      }

      showStep(stepNumber) {
        this.steps.forEach((step) => { step.hidden = Number(step.dataset.step) !== stepNumber; });
        this.progress.forEach((item) => {
          const itemStep = Number(item.dataset.progressStep);
          item.classList.toggle('is-active', itemStep === stepNumber);
          item.classList.toggle('is-complete', itemStep < stepNumber);
        });
        const planner = this.querySelector('.herdio-home__planner');
        if (planner && !Shopify.designMode) planner.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      renderResult() {
        const space = this.spaceData[this.answers.space];
        if (!space) return;
        const product = space.products[this.answers.size] || space.products.medium || space.products.small || space.products.large;
        const sizeButton = this.querySelector(`[data-size="${this.answers.size}"] strong`);
        const connectionButton = this.querySelector(`[data-connection="${this.answers.connection}"] strong`);
        this.setText('[data-answer-space]', space.title);
        this.setText('[data-answer-size]', sizeButton ? sizeButton.textContent : '');
        this.setText('[data-answer-connection]', connectionButton ? connectionButton.textContent : '');
        this.setText('[data-fit-copy]', space.fitCopy);
        this.setText('[data-product-title]', product.title);
        this.setText('[data-product-description]', product.description);
        this.setText('[data-product-price]', product.price);
        const image = this.querySelector('[data-product-image]');
        if (image) {
          image.src = product.image || '';
          image.alt = product.title || '';
          image.hidden = !product.image;
        }
        const productLink = this.querySelector('[data-product-link]');
        const solutionLink = this.querySelector('[data-solution-link]');
        if (productLink) productLink.href = product.url || space.solutionUrl;
        if (solutionLink) solutionLink.href = space.solutionUrl;
      }

      setText(selector, value) {
        const element = this.querySelector(selector);
        if (element) element.textContent = value || '';
      }

      resetPlanner() {
        this.answers = {};
        this.querySelectorAll('[aria-pressed]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
        this.showStep(1);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["herdio-system-kits"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('herdio-system-kit')) {
    customElements.define('herdio-system-kit', class extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector('[data-kit-add]');
        if (!button) return;
        button.addEventListener('click', async () => {
          const itemsElement = this.querySelector('[data-kit-items]');
          if (!itemsElement) return;
          const items = JSON.parse(itemsElement.textContent);
          if (!items.length) return;
          const originalText = button.textContent;
          button.disabled = true;
          button.textContent = button.dataset.addingText;
          try {
            const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items })
            });
            if (!response.ok) throw new Error('Cart request failed');
            window.location.href = `${window.Shopify.routes.root}cart`;
          } catch (error) {
            button.disabled = false;
            button.textContent = button.dataset.errorText;
            window.setTimeout(() => { button.textContent = originalText; }, 2400);
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
